// ============================================================================
// PRODUCTS DATA WITH FULL SPECS
// ============================================================================

export const products = [
  // ========== SOLAR: ETC (Evacuated Tube Collector) ==========
  {
    id: 1,
    name: "Heavy Plus 110 LPD",
    category: "solar",
    price: 18500,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "ETC | 110 LPD",
    image: "/images/hp110.jpeg",
    description:
      "Compact ETC system for small families with quick morning heat-up and low upkeep. Three-layered evacuated glass tubes ensure consistent heating even in cloudy weather.",
    features: [
      "Three-layer evacuated glass tubes",
      "Heavy Plus build quality",
      "Fast morning heating",
      "Weather resistant",
      "Low maintenance required",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "ETC (Evacuated Tube)",
      capacity: "110 LPD",
      suitableFor: "2–3 family members / 1 bathroom",
      tankMaterial: "Glass Lining (Inner), Galvanized (Outer)",
      insulation: "PUF 50mm (Polyurethane Foam)",
      collarTubes: "Number of tubes depends on capacity",
      standFrame: "Galvanized & Power Coated",
      weldingMethod: "Seamless & Non-Welding Technology",
      maxTemperature: "65°C - 70°C",
      idealFor: "North/South Indian homes, annual sunshine",
      installation: "Rooftop, needs direct sunlight, includes basic plumbing",
    },
    faqs: [
      {
        q: "Does it work in winter?",
        a: "Yes. Evacuated tubes absorb sunlight even on cloudy days. In winter, you'll get hot water in early morning hours.",
      },
      { q: "What is the lifespan?", a: "10–15 years with proper maintenance. Glass tubes may need replacement after 8–10 years." },
      { q: "Do you provide installation?", a: "Yes, with site inspection, structural assessment, and plumbing work included." },
      {
        q: "Can it be installed on all roof types?",
        a: "Most roof types supported. RCC, mild steel, or tile roofs work well. We assess and confirm during site visit.",
      },
    ],
  },

  {
    id: 2,
    name: "Heavy Plus 165 LPD",
    category: "solar",
    price: 22500,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "ETC | 165 LPD",
    image: "/images/hp165.png",
    description:
      "Balanced 165 LPD capacity ideal for 3–4 members with robust insulation and premium tubing. Reliable hot water throughout the year.",
    features: [
      "Three-layer evacuated glass tubes",
      "Robust build quality",
      "Enhanced heat retention",
      "Quick heating cycles",
      "Weather resistant",
      "Low maintenance",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "ETC (Evacuated Tube)",
      capacity: "165 LPD",
      suitableFor: "3–4 family members / 2 bathrooms (part-time)",
      tankMaterial: "Glass Lining (Inner), Galvanized (Outer)",
      insulation: "PUF 50mm (Polyurethane Foam)",
      standFrame: "Galvanized & Power Coated",
      maxTemperature: "65°C - 70°C",
      idealFor: "Bengaluru, Tamil Nadu, Andhra Pradesh regions",
      installation: "Rooftop with 30° south-facing angle preferred",
    },
    faqs: [
      { q: "Is it better than 110 LPD?", a: "Yes, larger tank means more hot water storage and longer usage hours per day." },
      {
        q: "What about maintenance?",
        a: "Minimal maintenance. Annual inspection recommended. Tubes last 8–10 years before replacement.",
      },
      { q: "Can I add backup heating?", a: "Yes, we offer gas/electric backup integration. Costs ₹3,000–₹8,000 extra." },
    ],
  },

  {
    id: 3,
    name: "Heavy Plus 200 LPD",
    category: "solar",
    price: 26000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "ETC | 200 LPD",
    image: "/images/hp110.jpeg",
    description:
      "Popular family-size ETC with reliable hot water across most seasons at low cost. Trusted by thousands of households in India.",
    features: [
      "Three-layer evacuated glass tubes",
      "Robust insulation",
      "Heavy-duty frame",
      "Consistent 70°C output",
      "Low electricity consumption",
      "Minimal maintenance",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "ETC (Evacuated Tube)",
      capacity: "200 LPD",
      suitableFor: "4–5 family members / 2 bathrooms",
      tankMaterial: "Glass Lining (Inner), Galvanized (Outer)",
      insulation: "PUF 50mm",
      standFrame: "Galvanized Power Coated Steel",
      maxTemperature: "65°C - 70°C",
      connectors: "Stainless Steel",
      fasteners: "Stainless Steel",
      idealFor: "Middle-class homes, VPOs, small colonies",
      installation: "Professional rooftop installation with 48-hour testing",
    },
    faqs: [
      { q: "How many hours of hot water daily?", a: "Depends on sunlight. Typical 4–6 hours in winter, 8–10 in summer." },
      { q: "Is plumbing complex?", a: "No, we handle it. Standard integration with existing geysers and tanks." },
      {
        q: "What if I need more backup?",
        a: "You can add immersion heater (₹500–₹2,000) or electric geyser in-line.",
      },
    ],
  },

  {
    id: 4,
    name: "Heavy Plus 220 LPD",
    category: "solar",
    price: 27500,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "ETC | 220 LPD",
    image: "/images/hp220.webp",
    description: "Extra headroom for larger households and peak-hour demand. Maintains comfortable water temperature even with multiple simultaneous uses.",
    features: [
      "Three-layer evacuated glass tubes",
      "Premium tank insulation",
      "Heavy-duty construction",
      "Fast heat recovery",
      "Zero electricity cost operation",
      "Eco-friendly",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "ETC (Evacuated Tube)",
      capacity: "220 LPD",
      suitableFor: "4–6 family members / 2+ bathrooms",
      tankMaterial: "Glass Lining (Inner), Galvanized (Outer)",
      insulation: "PUF 50mm Polyurethane Foam",
      standFrame: "Galvanized Power Coated",
      pressureRating: "Normal (Non-Pressurized)",
      maxTemperature: "65°C - 70°C",
      ideal: "Duplex homes, farms, small guest houses",
    },
    faqs: [
      { q: "Can I get hot water in peak hours?", a: "Yes, larger tank stores more heat. Peak hour usage supported well." },
      {
        q: "Do I need a backup heater?",
        a: "In winter months (Nov–Feb), a 1–2 kW immersion heater recommended.",
      },
    ],
  },

  {
    id: 5,
    name: "Heavy Plus 270 LPD",
    category: "solar",
    price: 34000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "ETC | 270 LPD",
    image: "/images/hp220.webp",
    description: "Higher capacity system for duplexes or two bathrooms running in parallel. Consistent hot water supply throughout peak usage hours.",
    features: [
      "Extra-large capacity",
      "Heavy-duty frame",
      "Premium insulation",
      "Simultaneous multi-use support",
      "Weather resistant",
      "Minimal corrosion",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "ETC (Evacuated Tube)",
      capacity: "270 LPD",
      suitableFor: "6–7 family members / 2–3 bathrooms",
      tankMaterial: "Glass Lining (Inner), Galvanized (Outer)",
      insulation: "PUF 50mm",
      standFrame: "Galvanized Power Coated Steel",
      maxTemperature: "65°C - 70°C",
      idealFor: "Duplex homes, villas, guest houses, small commercial",
    },
    faqs: [
      { q: "Will it fit on my roof?", a: "Most roof sizes accommodate 270L. We do structural assessment at site." },
      { q: "Is 270L really needed for 6 members?", a: "Yes, for 2–3 bathrooms with morning + evening showers running simultaneously." },
    ],
  },

  {
    id: 6,
    name: "Heavy Plus 300 LPD",
    category: "solar",
    price: 42000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "ETC | 300 LPD",
    image: "/images/hp300.jpeg",
    description:
      "300 LPD ETC with efficient heat retention for families with frequent usage. Premium option for homes prioritizing consistent hot water availability.",
    features: [
      "Large-capacity storage",
      "Heavy-duty construction",
      "Enhanced heat retention",
      "Premium insulation",
      "Multi-simultaneous-use support",
      "Long lifespan",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "ETC (Evacuated Tube)",
      capacity: "300 LPD",
      suitableFor: "7–8 family members / 3 bathrooms",
      tankMaterial: "Glass Lining (Inner), Galvanized (Outer)",
      insulation: "PUF 50mm Premium Grade",
      standFrame: "Galvanized Power Coated Heavy-Duty",
      pressureRating: "Normal Non-Pressurized",
      maxTemperature: "65°C - 70°C",
      warranty: "5 Years on Tank, 2 Years on Tubes",
      ideal: "Villas, large families, small resorts",
    },
    faqs: [
      {
        q: "Is 300 LPD too much for a home?",
        a: "Not if you have 7+ family members or frequent guests. Extra capacity is never wasted.",
      },
      { q: "Does it cost too much to maintain?", a: "Maintenance cost is minimal—just annual inspection." },
    ],
  },

  {
    id: 7,
    name: "Heavy Plus 500 LPD",
    category: "solar",
    price: 72000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "ETC | 500 LPD",
    image: "/images/hp500.jpeg",
    description:
      "Large-capacity ETC solution for villas and small commercial needs. Premium hot water supply for high-demand environments.",
    features: [
      "Large-capacity storage",
      "Industrial build quality",
      "Heavy-duty frame and stands",
      "Maximum heat retention",
      "Supports high water flow",
      "Professional installation",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "ETC (Evacuated Tube)",
      capacity: "500 LPD",
      suitableFor: "10+ family members / Large villa / Small commercial",
      tankMaterial: "Glass Lining (Inner), Galvanized (Outer)",
      insulation: "PUF 50mm Premium Grade",
      standFrame: "Galvanized Power Coated Heavy-Duty",
      pressureRating: "Normal (Non-Pressurized)",
      maxTemperature: "65°C - 70°C",
      warranty: "5 Years on Tank, 2 Years on Tubes",
      ideal: "Villas, resorts, guest houses, small hotels",
    },
    faqs: [
      { q: "Can I install this alone?", a: "No, requires professional team. We handle complete installation + testing." },
      { q: "What about roof load?", a: "We assess structural capacity. Most RCC roofs handle 500L system." },
    ],
  },

  // ========== SOLAR: FPC Non-Pressurized ==========
  {
    id: 8,
    name: "FPC Non-Pressurized 220 LPD",
    category: "solar",
    price: 68000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "FPC | 220 LPD",
    image: "/images/fpc-220.jpg",
    description:
      "Flat Plate Collector with durable absorber and stable performance in varied climates. Better suited for frequent draw-offs and coastal areas.",
    features: [
      "1.2mm Aluminium section",
      "High-efficiency flat plate collector",
      "Fiber glass wool insulation",
      "Copper header pipes",
      "Stable performance year-round",
      "Premium materials",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "FPC (Flat Plate Collector)",
      capacity: "220 LPD",
      pressureType: "Non-Pressurized",
      suitableFor: "3–4 family members with frequent hot water needs",
      collectorSection: "1.2mm thick Aluminium",
      backSheet: "0.46mm thick Aluminium",
      insulation: "Fiber Glass Wool",
      glassGlazing: "1000 x 2000 x 4mm Toughened Glass",
      headerPipe: "Copper 24 SWG",
      foil: "0.05mm Aluminium",
      innerTank: "1.2mm C.R.C.A. Steel with Prime Guard Coating",
      tankInsulation: "PUF 50mm",
      connectors: "Stainless Steel",
      idealFor: "Coastal areas, areas with moderate pressure water",
    },
    faqs: [
      {
        q: "Why FPC instead of ETC?",
        a: "FPC handles frequent hot water draw-offs better. Good for showers and daily use.",
      },
      {
        q: "Does it work in coastal climates?",
        a: "Yes, FPC's flat design is better for coastal wind and humidity.",
      },
      { q: "Is maintenance easier?", a: "Slightly easier than ETC. No fragile glass tubes." },
    ],
  },

  {
    id: 9,
    name: "FPC Non-Pressurized 275 LPD",
    category: "solar",
    price: 81000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "FPC | 275 LPD",
    image: "/images/fpc-275.jpg",
    description:
      "Higher non-pressurized FPC capacity with consistent delivery and low losses. Ideal for mid-sized families with regular hot water usage.",
    features: [
      "Flat plate aluminium collector",
      "Consistent temperature output",
      "Low heat loss design",
      "Durable absorber coating",
      "Efficient year-round performance",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "FPC (Flat Plate Collector)",
      capacity: "275 LPD",
      pressureType: "Non-Pressurized",
      suitableFor: "4–5 family members",
      collectorSection: "1.2mm Aluminium",
      insulation: "Fiber Glass Wool",
      tankInsulation: "PUF 50mm",
      pressureRating: "Low-pressure (suitable for gravity systems)",
      idealFor: "Areas with lower water pressure, frequent usage",
    },
    faqs: [
      { q: "What's better—ETC or FPC?", a: "ETC: better in winter/cloudy weather. FPC: better for frequent draw-offs." },
      { q: "Can I retrofit with backup?", a: "Yes, add 2–3 kW electric backup easily." },
    ],
  },

  {
    id: 10,
    name: "FPC Non-Pressurized 300 LPD",
    category: "solar",
    price: 98000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "FPC | 300 LPD",
    image: "/images/fpc-300.jpg",
    description:
      "300 LPD FPC suited for frequent draw-offs and steady temperature output. Premium non-pressurized system for large households.",
    features: [
      "Large-capacity flat plate collector",
      "Stable 65–70°C output",
      "Minimal heat loss",
      "Durable absorber surface",
      "Excellent flow rate",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "FPC (Flat Plate Collector) Non-Pressurized",
      capacity: "300 LPD",
      suitableFor: "6–7 family members",
      collectorSection: "1.2mm Aluminium (Premium Grade)",
      insulation: "Fiber Glass Wool + PUF Tank Insulation",
      glassGlazing: "Toughened tempered glass",
      connectors: "Stainless Steel",
      idealFor: "Families with high daily hot water demand",
    },
    faqs: [
      { q: "Is 300L FPC better than 300L ETC?", a: "Different use cases: FPC for frequent use, ETC for cold climates." },
      { q: "What pressure does it need?", a: "Minimal pressure (0.3–1 kg/cm²). Gravity/low-pressure systems work." },
    ],
  },

  // ========== SOLAR: FPC Pressurized ==========
  {
    id: 11,
    name: "FPC Pressurized 220 LPD",
    category: "solar",
    price: 82000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "FPC | 220 LPD | Pressurized",
    image: "/images/fpc-p-220.jpeg",
    description:
      "Pressurized FPC system for high line pressure homes and premium bath fittings. Supports rain showers and luxury bath fixtures.",
    features: [
      "Pressurized flat plate collector",
      "High line pressure support",
      "Luxury rain shower compatible",
      "Durable tank (3mm premium)",
      "Stable output",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "FPC (Flat Plate Collector) Pressurized",
      capacity: "220 LPD",
      pressureType: "Pressurized (2.5–4 kg/cm²)",
      suitableFor: "3–4 members with high-pressure shower needs",
      tankMaterial: "2.5mm C.R.C.A. Steel with Prime Guard Coating",
      tankInsulation: "PUF 50mm",
      maxPressure: "4 kg/cm²",
      connectors: "Copper & Stainless Steel",
      ideal: "Homes with high line pressure, rain showers, whirlpool baths",
    },
    faqs: [
      { q: "Can I use rain showers?", a: "Yes, pressurized system supports rain showers and high-flow fixtures." },
      { q: "Is it more expensive?", a: "Yes, ₹5–8K more than non-pressurized due to premium tank material." },
      { q: "What water pressure is needed?", a: "Minimum 2.5 kg/cm², maximum 4 kg/cm²." },
    ],
  },

  {
    id: 12,
    name: "FPC Pressurized 275 LPD",
    category: "solar",
    price: 110000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "FPC | 275 LPD | Pressurized",
    image: "/images/275-FPC.jpg",
    description:
      "Balanced pressurized capacity supporting multi-bath usage without drop in flow. Premium system for upscale homes.",
    features: [
      "Pressurized flat plate system",
      "Multi-bath support",
      "No flow drop during usage",
      "Premium materials throughout",
      "High durability",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "FPC Pressurized",
      capacity: "275 LPD",
      pressureType: "Pressurized (2.5–4 kg/cm²)",
      suitableFor: "4–5 members with 2–3 bathrooms",
      tankMaterial: "3mm C.R.C.A. Steel (Premium Grade)",
      maxPressure: "4 kg/cm²",
      connectors: "Copper Pipes with Stainless Fittings",
      ideal: "Luxury homes, villas, homes with multiple rain showers",
    },
    faqs: [
      { q: "Can both showers run hot water simultaneously?", a: "Yes, 275L supports 2 simultaneous showers easily." },
      { q: "Is warranty same?", a: "Yes, 5-year tank warranty, 2-year collector warranty." },
    ],
  },

  {
    id: 13,
    name: "FPC Pressurized 300 LPD",
    category: "solar",
    price: 155000,
    warranty: "20 Years (Terms & Conditions Apply)",
    efficiency: "FPC | 300 LPD | Pressurized",
    image: "/images/fpc-p-300.jpg",
    description:
      "Top-tier pressurized FPC for rain showers and long pipelines with steady output. Premium solution for luxury homes.",
    features: [
      "Premium pressurized system",
      "Supports long pipelines",
      "Steady high-pressure output",
      "Heavy-duty tank (3mm)",
      "Multiple simultaneous uses",
    ],
    specs: {
      brand: "Supreme",
      collectorType: "FPC Pressurized (Premium)",
      capacity: "300 LPD",
      pressureType: "Pressurized (2.5–4 kg/cm²)",
      suitableFor: "6–7 members / 3+ bathrooms",
      tankMaterial: "3mm premium C.R.C.A. Steel",
      tankInsulation: "PUF 50mm High-density",
      maxPressure: "4 kg/cm²",
      connectors: "Copper pipes with brass fittings",
      warranty: "5 Years Tank, 2 Years Collector",
      ideal: "Villas, luxury homes, long pipeline runs",
    },
    faqs: [
      { q: "Is 300L FPC pressurized the best?", a: "Yes, for luxury + frequent use in high-pressure homes." },
      { q: "Does long pipeline affect output?", a: "Pressurized system maintains flow even with 50m+ pipe runs." },
    ],
  },



  // ========== WATER PURIFIERS ==========
  {
    id: 16,
    name: "Aqua Grand RO",
    category: "purifier",
    price: 7000,
    warranty: "1 Year",
    efficiency: "RO | Household",
    image: "/images/AquagrandRO.jpg",
    description: "Budget RO for essential daily drinking needs with serviceable filters. Simple, affordable entry-level purification.",
    features: ["RO filtration", "Carbon polishing", "Serviceable filters", "Compact design", "Budget-friendly"],
    specs: {
      brand: "Aqua",
      purificationType: "RO (Reverse Osmosis)",
      stages: "3–4 stages (sediment, carbon, RO, post-carbon)",
      storageCapacity: "3–5 Litres",
      flowRate: "8–10 LPH",
      tdsRange: "Up to 2000 ppm input",
      filterLife: "12–18 months (depends on TDS)",
      warranty: "1 Year",
      installation: "Wall-mounted or counter-top",
      maintenance: "Filter change every 12–18 months (₹1,500–2,000)",
      ideal: "Small families, budget-conscious, low-TDS areas",
    },
    faqs: [
      { q: "Is budget RO safe?", a: "Yes, RO membrane removes 99% impurities. 'Budget' means fewer extra features." },
      { q: "How often to change filters?", a: "Every 12–18 months depending on water quality and usage." },
      { q: "What TDS should be acceptable?", a: "Below 300 ppm is ideal. Above 500 ppm needs RO+other treatments." },
    ],
  },

  {
    id: 17,
    name: "Aqua Pearl RO",
    category: "purifier",
    price: 8500,
    warranty: "1 Year",
    efficiency: "RO | Household",
    image: "/images/Aqua-Pearl-RO.jpg",
    description: "Value RO with dependable purification and easy wall-mount design. Mid-range option with balanced features.",
    features: ["Core RO filtration", "Sediment + carbon pre-filter", "Wall-mount ready", "Serviceable", "Mid-range cost"],
    specs: {
      brand: "Aqua",
      purificationType: "RO (Reverse Osmosis)",
      stages: "3–4 stages",
      storageCapacity: "4–7 Litres",
      flowRate: "10–12 LPH",
      tdsRange: "Up to 2000 ppm",
      filterLife: "12–18 months",
      warranty: "1 Year",
      installation: "Wall-mounted (compact)",
      ideal: "Small to mid-size families, moderate water quality",
    },
    faqs: [
      { q: "What's the difference from Aqua Grand?", a: "Better flow rate (LPH), slightly larger storage, wall-mount friendly." },
      { q: "Is it better than costlier models?", a: "Core purification is same. Extra cost buys extras like UV, taste enhancer, TDS control." },
    ],
  },

  {
    id: 18,
    name: "Copper Pearl RO",
    category: "purifier",
    price: 9500,
    warranty: "1 Year",
    efficiency: "RO | Household",
    image: "/images/copperpearlro.jpg",
    description: "RO with copper enrichment for taste and hygiene-focused households. Adds mineral richness to purified water.",
    features: ["Copper enrichment cartridge", "RO filtration", "Taste enhancer", "Filter alerts", "Sleek design"],
    specs: {
      brand: "Aqua",
      purificationType: "RO + Copper Enrichment",
      stages: "4 stages (sediment, carbon, RO, copper/mineral)",
      storageCapacity: "5–7 Litres",
      flowRate: "10–12 LPH",
      tdsRange: "Up to 2000 ppm",
      copperBenefit: "Adds copper minerals for better taste & skin health",
      filterLife: "12–18 months",
      warranty: "1 Year",
      installation: "Wall-mounted",
      ideal: "Health-conscious families, areas with bad-tasting water",
    },
    faqs: [
      { q: "Is copper water safe?", a: "Yes, in small amounts (from enrichment cartridge). Enhances taste + provides antimicrobial benefits." },
      { q: "Do I need copper water?", a: "Not essential but nice-to-have. Better taste, slight health benefits." },
    ],
  },

  {
    id: 19,
    name: "Purosis RO",
    category: "purifier",
    price: 11500,
    warranty: "1 Year",
    efficiency: "RO | Household",
    image: "/images/purosisro.jpg",
    description: "Trusted RO brand with essential multi-stage filtration and reliable build. Good middle-ground option.",
    features: ["Multi-stage RO", "Reliable build quality", "Serviceable filters", "Compact body", "Budget-friendly"],
    specs: {
      brand: "Purosis",
      purificationType: "RO (Reverse Osmosis)",
      stages: "4 stages",
      storageCapacity: "5–7 Litres",
      flowRate: "10–12 LPH",
      tdsRange: "Up to 2000 ppm",
      filterLife: "12–18 months",
      warranty: "1 Year (India-wide service)",
      installation: "Wall-mounted or counter-top",
      ideal: "Mid-size families, reliable Indian brand preferred",
    },
    faqs: [
      { q: "Is Purosis a trusted brand?", a: "Yes, established brand with 10+ years in market, good service network." },
      { q: "How's warranty support?", a: "India-wide service centers. Complaints resolved in 24–48 hours." },
    ],
  },

  {
    id: 20,
    name: "Innovica RO",
    category: "purifier",
    price: 12000,
    warranty: "1 Year",
    efficiency: "RO | Household",
    image: "/images/aqua innovacia.jpg",
    description: "Balanced RO for daily use with low TDS compatibility and easy maintenance. Good all-rounder option.",
    features: ["RO + Carbon combo", "Low TDS compatible", "Easy maintenance", "Compact design", "Quick filter changes"],
    specs: {
      brand: "Innovica (Aqua)",
      purificationType: "RO (Reverse Osmosis)",
      stages: "4 stages (pre-sediment, carbon, RO, post-carbon)",
      storageCapacity: "5–7 Litres",
      flowRate: "10–12 LPH",
      tdsRange: "Up to 1500 ppm",
      filterLife: "12–18 months",
      warranty: "1 Year",
      installation: "Wall-mounted",
      maintenance: "DIY filter change (easy, no tools)",
      ideal: "Moderate water quality, budget-conscious families",
    },
    faqs: [
      { q: "Is DIY filter change easy?", a: "Yes, push-fit cartridges. No wrench needed. ~5 minutes to change." },
      { q: "What if TDS is very high (>1500)?", a: "Upgrade to KENT or Aquaguard with TDS control." },
    ],
  },

  {
    id: 21,
    name: "Finpure RO",
    category: "purifier",
    price: 13000,
    warranty: "1 Year",
    efficiency: "RO | Household",
    image: "/images/finpure.png",
    description: "Premium RO with refined filtration, indicators and durable components. Enhanced features for health-focused users.",
    features: [
      "Enhanced taste filtration",
      "Durable components (stainless steel valve)",
      "Alert indicators (filter life, tank full)",
      "Easy service",
      "Aesthetic design",
    ],
    specs: {
      brand: "Finpure",
      purificationType: "RO (Reverse Osmosis)",
      stages: "4–5 stages (pre-filter, carbon, RO, taste enhancer, post-carbon)",
      storageCapacity: "6–8 Litres",
      flowRate: "12–14 LPH",
      tdsRange: "Up to 2000 ppm",
      filterAlerts: "Yes (LED indicator for filter life)",
      tankFullAlert: "Yes",
      valves: "Stainless Steel (premium)",
      filterLife: "12–18 months",
      warranty: "1 Year",
      installation: "Wall-mounted",
      ideal: "Health-conscious families, high-TDS areas, premium budgets",
    },
    faqs: [
      { q: "Why is Finpure expensive?", a: "Better filtration, alerts, durable valves. Better taste & peace of mind." },
      { q: "Do I really need taste enhancer?", a: "If water tastes bad/metallic, yes. Otherwise, basic RO is fine." },
    ],
  },

  {
    id: 22,
    name: "Aquaguard RO+UV+UF 7L",
    category: "purifier",
    price: 15499,
    originalPrice: 17499,
    warranty: "1 Year",
    efficiency: "7 L | 15 LPH",
    image: "/images/aquaguardro.webp",
    description:
      "Trusted multi-stage RO+UV+UF with taste enhancer for urban water conditions. Premium brand, comprehensive purification.",
    features: [
      "RO (Reverse Osmosis) – removes TDS",
      "UV (Ultraviolet) – kills bacteria/viruses",
      "UF (Ultrafiltration) – removes suspended particles",
      "Taste enhancer cartridge",
      "Built-in pre-filter",
      "Smart alerts (filter life, tank full)",
      "Aquaguard brand trust",
    ],
    specs: {
      brand: "Aquaguard",
      purificationType: "RO+UV+UF (3-stage combined)",
      stages: "5+ (pre-filter, RO, UV, UF, taste enhancer, post-carbon)",
      storageCapacity: "7 Litres",
      flowRate: "15 LPH",
      tdsRange: "Up to 2000 ppm input",
      waterSavings: "Low wastage design (4:1 ratio good)",
      builtInPreFilter: "Yes (50 micron sediment)",
      uvPower: "8 W",
      filterLife: "12–18 months",
      warranty: "1 Year (Aquaguard brand service)",
      serviceAvailability: "Pan-India (excellent service network)",
      installation: "Wall-mounted",
      ideal: "Urban homes with variable water quality, brand-conscious families",
      annualServiceCost: "₹2,000–3,000 (filter + maintenance)",
    },
    faqs: [
      {
        q: "Is RO+UV+UF better than RO alone?",
        a: "Yes. RO removes salts/TDS, UV kills bacteria/viruses, UF removes particles. Triple protection.",
      },
      { q: "Aquaguard brand—is it reliable?", a: "Yes, 20+ years in market, trusted by millions, excellent service support." },
      { q: "What if water is very hard?", a: "RO handles high hardness. For very hard water, add water softener separately." },
      { q: "Service cost?", a: "Annual filter change + maintenance ≈ ₹2,000–3,000." },
    ],
  },

  {
    id: 23,
    name: "KENT Grand Plus RO+UV+UF+TDS 8L",
    category: "purifier",
    price: 16999,
    originalPrice: 19999,
    warranty: "1 Year",
    efficiency: "8 L | 20 LPH",
    image: "/images/kentro.jpg",
    description:
      "Advanced purification with TDS control, mineral retention and UV in-tank. Premium option for complete water treatment.",
    features: [
      "RO+UV+UF+TDS Control (4-stage)",
      "TDS Control valve (adjust mineral level)",
      "Mineral retention (healthier water)",
      "UV light in-tank (continuous disinfection)",
      "Zero water wastage design",
      "Taste enhancer",
      "Low power consumption",
      "Smart alerts",
    ],
    specs: {
      brand: "KENT",
      purificationType: "RO+UV+UF+TDS (4-stage purification)",
      stages: "6+ (pre-filter, RO, UV, UF, TDS control, post-carbon)",
      storageCapacity: "8 Litres",
      flowRate: "20 LPH",
      tdsRange: "Up to 2000 ppm input, adjustable output (100–500 ppm)",
      tdsControl: "Yes (adjust mineral level for taste + health)",
      mineralRetention: "15–30% minerals retained (vs 0% in plain RO)",
      uvInTank: "Yes (continuous disinfection)",
      wastageRatio: "Low (4:1 to 3:1)",
      powerConsumption: "Low",
      warranty: "1 Year (KENT Pan-India service)",
      installation: "Wall-mounted",
      ideal: "Health-conscious families, high-TDS areas, premium segment, long-term solution",
      annualServiceCost: "₹2,500–3,500",
    },
    faqs: [
      {
        q: "What is TDS control?",
        a: "Valve lets you adjust minerals in output. 100 ppm = safer but less taste. 500 ppm = more minerals for taste.",
      },
      {
        q: "Is mineral retention important?",
        a: "Yes, plain RO removes all minerals (risky long-term). KENT's TDS control retains essential minerals.",
      },
      { q: "Why is it ₹16,999 when Aquaguard is ₹15,499?", a: "TDS control + mineral retention + better filtration = premium price justified." },
      { q: "Does KENT have good service?", a: "Yes, excellent service network. Faster support than competitors." },
      {
        q: "Long-term worth?",
        a: "Yes. Pays for itself in health benefits. Costs ~₹1.50–2/L after installation+service.",
      },
    ],
  },

  {
    id: 24,
    name: "Dolphin RO",
    category: "purifier",
    price: 7500,
    warranty: "1 Year",
    efficiency: "RO | Household",
    image: "/images/dolphin.jpg",
    description: "Sturdy RO with robust housing and reliable output for small families. Simple, durable, affordable.",
    features: ["Robust housing", "RO filtration", "Service support", "Reliable output", "Compact"],
    specs: {
      brand: "Dolphin",
      purificationType: "RO (Reverse Osmosis)",
      stages: "3–4 stages",
      storageCapacity: "5–7 Litres",
      flowRate: "10–12 LPH",
      tdsRange: "Up to 2000 ppm",
      housing: "Heavy plastic (durable)",
      filterLife: "12–18 months",
      warranty: "1 Year",
      installation: "Wall-mounted",
      ideal: "Budget-conscious, small families, rural areas",
    },
    faqs: [
      { q: "Is Dolphin a reliable brand?", a: "Yes, Indian brand, good value for money, decent service support." },
    ],
  },

  // ========== CHIMNEYS ==========
  {
    id: 25,
    name: "Supreme ECO H4 60 cm Auto-Clean",
    category: "chimney",
    price: 12999,
    originalPrice: 15999,
    warranty: "1 Year",
    efficiency: "1200 m³/hr",
    image: "/images/chimney1.png",
    description:
      "Auto-clean wall-mount chimney with touch controls and bright LED lighting. Budget-friendly with smart auto-cleaning.",
    features: [
      "Auto-clean baffle filter",
      "Touch controls (digital)",
      "LED lamps (bright)",
      "Low noise operation",
      "Wall-mounted (space-saving)",
      "Energy efficient",
    ],
    specs: {
      brand: "Supreme",
      type: "Wall-Mounted Chimney",
      width: "60 cm",
      suctionCapacity: "1200 m³/hour",
      filterType: "Auto-Clean Baffle Filter (aluminum)",
      controls: "Touch panel (3-speed)",
      led: "Yes (bright LED lighting)",
      oilCollector: "Yes (easy cleanup)",
      noise: "Low (≈60 dB)",
      power: "0.45–0.6 kW",
      installation: "Wall-mounted (pipes to outside)",
      warranty: "1 Year (parts + labor)",
      ideal: "Budget kitchens, small cooking areas, noise-sensitive homes",
    },
    faqs: [
      { q: "How does auto-clean work?", a: "Filter vibrates to shake off oil deposits. Manual cleaning still needed quarterly." },
      { q: "1200 m³/hr—is it enough?", a: "Yes for 60 cm width. Adequate for normal Indian cooking (daily spice/oil cooking)." },
      { q: "Can I install myself?", a: "DIY possible but professional installation recommended (ductwork, electricity). ₹1,500–3,000 install cost." },
      { q: "How often to clean?", a: "Quarterly deep clean. Monthly wipe-down of visible grease." },
    ],
  },

  {
    id: 26,
    name: "Supreme FIGO XL 90 cm Touch",
    category: "chimney",
    price: 17999,
    originalPrice: 20999,
    warranty: "1 Year",
    efficiency: "1400 m³/hr",
    image: "/images/chimney2.jpg",
    description:
      "Wide 90 cm canopy for heavy cooking with high suction and simple upkeep. Premium option for larger kitchens.",
    features: [
      "90 cm wide canopy (covers large stove)",
      "High suction (1400 m³/hr)",
      "Touch panel controls",
      "Oil collector tray",
      "LED lamps",
      "Dual filter option",
      "Low noise",
    ],
    specs: {
      brand: "Supreme",
      type: "Wall-Mounted Chimney",
      width: "90 cm",
      suctionCapacity: "1400 m³/hour (high)",
      filterType: "Baffle Filter (aluminum, replaceable)",
      controls: "Touch panel (3-speed)",
      led: "Yes",
      oilCollector: "Yes (deep tray)",
      noise: "Low (≈62 dB)",
      power: "0.6–0.75 kW",
      warranty: "1 Year",
      installation: "Professional installation recommended",
      ideal: "Large kitchens, heavy daily cooking (Indian masala cooking), 90+ cm stoves",
    },
    faqs: [
      { q: "Is 90 cm better than 60 cm?", a: "Yes, covers larger area, higher suction, better for heavy cooking." },
      { q: "1400 m³/hr—does it consume much power?", a: "≈60 W running cost. ~₹150–200/month if used 5 hours daily." },
      { q: "How to maintain?", a: "Monthly oil collector dump, quarterly filter wash, annual motor check." },
      { q: "Is installation expensive?", a: "Yes, 90 cm needs longer ductwork, larger opening. ₹2,000–5,000 install cost." },
    ],
  },

  {
    id: 27,
    name: "Supreme CROWN X 60 cm",
    category: "chimney",
    price: 14999,
    originalPrice: 17999,
    warranty: "1 Year",
    efficiency: "1100 m³/hr",
    image: "/images/chimney3.jpg",
    description:
      "Compact 60 cm chimney with efficient filtration and clean touch interface. Space-saving mid-range option.",
    features: [
      "Space-saving 60 cm size",
      "Touch controls",
      "Baffle/Mesh filter options",
      "Copper motor (durable)",
      "LED lighting",
      "Efficient suction",
      "Easy maintenance",
    ],
    specs: {
      brand: "Supreme",
      type: "Wall-Mounted Chimney",
      width: "60 cm",
      suctionCapacity: "1100 m³/hour",
      filterType: "Baffle & Mesh filter combo",
      motor: "Copper motor (durable, long life)",
      controls: "Touch panel (3-speed)",
      led: "Yes",
      oilCollector: "Yes",
      noise: "Low (≈60 dB)",
      power: "0.45–0.55 kW",
      warranty: "1 Year (Supreme service)",
      installation: "Wall-mounted",
      ideal: "Mid-size kitchens, daily cooking, space-constrained homes",
    },
    faqs: [
      { q: "Why 'CROWN X'?", a: "Premium positioning—better motor (copper), dual filter option." },
      { q: "Baffle vs Mesh filter?", a: "Baffle: low maintenance, mesh: frequent cleaning. This has both options." },
      { q: "Is copper motor really better?", a: "Yes, lasts longer (10+ years vs 5–7 for standard). Better heat dissipation." },
      { q: "Installation cost?", a: "₹1,500–2,500 (less than 90 cm models)." },
    ],
  },

  // ========== UPS ==========
  {
    id: 28,
    name: "Luminous Zelio+ 1100 Pure Sine Wave",
    category: "ups",
    price: 10500,
    originalPrice: 11990,
    warranty: "24 Months",
    efficiency: "900 VA | 756 W",
    image: "/images/lum1.jpg",
    description:
      "Smart sine wave UPS with LCD, fast changeover and dependable backup timing. Premium home inverter.",
    features: [
      "Pure Sine Wave technology",
      "32-bit DSP processor",
      "LCD display (shows status)",
      "Smart fast changeover",
      "Eco & UPS modes",
      "MCB protection",
      "Intelligent home UPS",
    ],
    specs: {
      brand: "Luminous",
      model: "Zelio+ 1100",
      type: "Pure Sine Wave Inverter",
      capacity: "1100 VA | 900 W",
      realPower: "756 W",
      technology: "32-bit DSP & LCD",
      waveType: "Pure Sine Wave (best for appliances)",
      batterySupported: "Single 12V battery",
      chargerCurrent: "15 A max",
      eco_mode: "Yes (saves power)",
      ups_mode: "Yes (battery backup)",
      protections: ["MCB protection", "Overload", "Short circuit", "Battery deep discharge"],
      warranty: "24 Months (2 Years)",
      weight: "10 kg",
      installation: "Floor-mounted (wall-mount possible)",
      ideal: "Small homes, 2-BHK, critical loads (lights, fans, WiFi, laptop)",
      batteryNeeded: "1x 150 Ah or equivalent (buy separately, ~₹8,000–12,000)",
      backupTime: "3–4 hours (depends on battery)",
    },
    faqs: [
      {
        q: "Pure sine wave vs square wave?",
        a: "Pure sine: safe for all appliances (AC, fridge, pump). Square wave: only for lights/fans.",
      },
      { q: "Do I need to buy battery?", a: "Yes, this is inverter only. Buy 150 Ah lead-acid or 100 Ah lithium battery." },
      { q: "How long will it last?", a: "Inverter: 10–15 years. Battery: 3–5 years (lead-acid) or 10+ (lithium)." },
      {
        q: "Can it run a refrigerator?",
        a: "Yes, pure sine wave is safe for compressors. Typical 250L fridge = 2–4 hours backup.",
      },
      { q: "Cost to fully set up?", a: "Inverter ₹10,500 + Battery ₹9,000 + Installation ₹1,500 = ~₹21,000 total." },
    ],
  },

  {
    id: 29,
    name: "Luminous Eco Watt Neo 1050",
    category: "ups",
    price: 8550,
    originalPrice: 9990,
    warranty: "24 Months",
    efficiency: "900 VA | 756 W",
    image: "/images/lum2.jpg",
    description:
      "Reliable home UPS with intelligent charging and wide input handling. Budget-friendly Luminous inverter.",
    features: [
      "Intelligent charging algorithm",
      "Square/Intelligent wave output",
      "Microprocessor-based",
      "MCB protection",
      "Eco & UPS modes",
      "Fast charging (from low voltage)",
      "Wide input range (90–280V)",
    ],
    specs: {
      brand: "Luminous",
      model: "Eco Watt Neo 1050",
      type: "Square Wave / Intelligent Wave Inverter",
      capacity: "900 VA | 756 W",
      waveType: "Square/Intelligent Wave (budget option)",
      batterySupported: "Single 12V battery",
      chargerCurrent: "17 A max",
      inputRange: "90–280V AC (wide voltage tolerance)",
      protections: ["MCB", "Overload", "Short circuit", "Deep discharge"],
      warranty: "24 Months",
      weight: "9.8 kg",
      installation: "Floor or wall-mount",
      ideal: "Budget homes, lights/fans only, 1–2 BHK, areas with fluctuating power",
      batteryNeeded: "1x 120–150 Ah (buy separately)",
      backupTime: "3–4 hours (depends on battery size)",
    },
    faqs: [
      {
        q: "Square wave—can it run AC/fridge?",
        a: "Not recommended. Use for lights, fans, laptop only. AC/fridge need pure sine wave.",
      },
      {
        q: "Why is it cheaper?",
        a: "Square wave is simpler tech. Pure sine wave costs more but safer for all appliances.",
      },
      { q: "Good for backup?", a: "Yes, if you only need lights/fans. For mixed loads, upgrade to sine wave." },
    ],
  },

  {
    id: 30,
    name: "Luminous Li-ON 1250 (In-built Lithium)",
    category: "ups",
    price: 69990,
    originalPrice: 74990,
    warranty: "60 Months",
    efficiency: "1250 VA | Li-ion",
    image: "/images/lum3.jpg",
    description:
      "Premium inverter with in-built Li-ion battery for compact, fast-charging backup. Future-proof home energy solution.",
    features: [
      "In-built Lithium-ion battery (≈1280 Wh)",
      "Pure Sine Wave output",
      "Fast charging (90 mins from 0–100)",
      "Silent operation",
      "Smart LCD display",
      "Compact & lightweight",
      "Low maintenance (no water top-up)",
      "5-year warranty (longest)",
    ],
    specs: {
      brand: "Luminous",
      model: "Li-ON 1250",
      type: "Pure Sine Wave with In-Built Li-Ion Battery",
      capacity: "1250 VA | 1000 W (approx)",
      battery: "Lithium-ion (in-built), ~1280 Wh",
      chargeTime: "90 minutes (0–100%)",
      waveType: "Pure Sine Wave",
      features: ["Smart LCD", "WiFi monitoring (optional)", "MCB protection", "Compact design"],
      protections: ["Overload", "Short circuit", "Temperature", "Deep discharge"],
      warranty: "60 Months (5 Years) on battery",
      lifespan: "10–15 years (Li-ion advantage)",
      weight: "25–30 kg (heavier, but portable)",
      installation: "Wall-mount or floor (compact size)",
      backupTime: "4–6 hours typical home loads",
      ideal: "Premium segment, long-term use, low maintenance needed, eco-conscious",
      annualCost: "~₹0 (no maintenance, no water, no acid top-up)",
      paybackPeriod: "7–8 years (vs lead-acid replacements)",
    },
    faqs: [
      {
        q: "Why is it ₹70K when Zelio+ is ₹10K?",
        a: "Li-ion battery included (worth ₹50K+). No need to buy separate battery. Lasts 10+ years vs 3–5 for lead-acid.",
      },
      {
        q: "Is lithium safe?",
        a: "Yes, LFP (Lithium Iron Phosphate) is safest. Thermal protection built-in. No explosion risk like old lithium.",
      },
      { q: "Do I need an electrician?", a: "Professional installation strongly recommended. Wiring must be correct." },
      {
        q: "Maintenance cost?",
        a: "Nearly zero. No water top-up, no acid spills, no terminal corrosion. Just occasional dust wipe.",
      },
      {
        q: "Best investment?",
        a: "Yes, if you plan 10+ years. Pays for itself in maintenance + battery replacement savings.",
      },
    ],
  },

  {
    id: 33,
    name: "Li-ion Inverter + Battery 1.1 kVA",
    category: "ups",
    price: 38999,
    originalPrice: 44999,
    warranty: "60 Months",
    efficiency: "1100 VA | 880 W",
    image: "/images/inverter.jpg",
    description:
      "Compact pure sine wave inverter with in-built 1280 Wh Li-ion battery for zero-maintenance backup, fast charging, and clean, silent operation.",
    features: [
      "In-built Li-ion battery (1280 Wh)",
      "Pure Sine Wave output",
      "Fast charging capability",
      "Ultra-low input voltage ready (charges from 90V)",
      "Wall-mount compact design",
      "Silent operation",
      "Smart LCD display",
      "Zero maintenance",
    ],
    specs: {
      brand: "Luminous (Premium Series)",
      model: "Li-ion Inverter + Battery 1.1 kVA",
      type: "Pure Sine Wave with In-Built Li-Ion Battery",
      capacity: "1100 VA | 880 W",
      battery: "In-built Li-ion, 1280 Wh",
      chargeTime: "2–3 hours (typical)",
      lowInputReady: "Yes, charges from as low as 90V AC",
      waveType: "Pure Sine Wave (safe for all appliances)",
      design: "Wall-mount, compact, space-saving",
      weight: "~20–25 kg",
      installation: "Wall-mounted or floor (compact)",
      protections: [
        "Overload protection",
        "Short circuit protection",
        "Temperature monitoring",
        "Deep discharge protection",
        "Battery management system (BMS)",
      ],
      warranty: "60 Months (5 Years) comprehensive",
      lifespan: "10–15 years (Li-ion)",
      backupTime: "4–6 hours for typical home (lights, fans, router, laptop)",
      display: "Smart LCD (shows charge %, load %, time remaining)",
      ideal: "Mid-premium homes, areas with frequent power cuts, low maintenance desired, compact space",
      annualMaintenance: "₹0 (no water, no acid, no topping)",
      scalability: "Can stack multiple units for higher capacity",
    },
    faqs: [
      {
        q: "What's included—do I buy battery separately?",
        a: "No, battery is built-in. Complete solution. No need for external 150L tank (saves space).",
      },
      {
        q: "Is ₹39K reasonable?",
        a: "Yes. Inverter (₹10K) + Battery (₹25K) + Installation = ~₹35K+ total if bought separately.",
      },
      {
        q: "Can it run a refrigerator?",
        a: "Yes, pure sine wave is safe. 250L fridge = 2–3 hours backup. Heavy loads reduce time.",
      },
      {
        q: "How long to charge from 0–100%?",
        a: "Typical 2–3 hours on normal supply. With low voltage (90V), takes ~4–5 hours.",
      },
      {
        q: "Is it better than lead-acid UPS?",
        a: "Much better: compact, silent, 10+ year life (vs 3–5), no maintenance, no spills, eco-friendly.",
      },
      {
        q: "Warranty—what if battery fails?",
        a: "60-month (5-year) warranty covers battery + inverter. Free replacement if defect.",
      },
      {
        q: "Can I add solar to this?",
        a: "Yes, solar charge controller can be integrated. Ask for solar-ready variant.",
      },
    ],
  },

  // ========== COMMERCIAL ==========
  {
    id: 14,
    name: "Commercial Solar Water Heater 3000 LPD",
    category: "solar-commercial",
    price: 335000,
    warranty: "5 Years",
    efficiency: "ETC/FPC | 3000 LPD",
    image: "/images/comm1.jpg",
    description:
      "High-volume system for hotels, hostels, hospitals and kitchens with engineered piping. Bulk hot water on demand.",
    features: [
      "3000 LPD capacity",
      "Bulk hot water supply",
      "Rooftop installation",
      "Low maintenance",
      "Industrial-grade build",
      "Engineered piping system",
      "Custom flow management",
    ],
    specs: {
      brand: "Supreme",
      capacity: "3000 LPD",
      system: "ETC/FPC hybrid (customizable)",
      tankCount: "Multiple (compartmentalized)",
      tankMaterial: "High-grade steel with industrial coating",
      installation: "Rooftop with structural assessment",
      pumpSystem: "Circulating pump (optional)",
      pipeNetwork: "Engineered copper/SS pipes",
      warranty: "5 Years (tank + collectors)",
      serviceSupport: "Dedicated on-call support",
      ideal: "Hotels, hostels, hospitals, industrial kitchens, resorts, guest houses",
      roi: "18–24 months (saves ₹80,000–150,000/year on heating)",
    },
    faqs: [
      {
        q: "What's the ROI for commercial?",
        a: "Saves ₹80,000–150,000/year on fuel/electricity. Pays back in 2–3 years.",
      },
      {
        q: "Do you provide engineering?",
        a: "Yes, we assess load, design piping, ensure water flow. Complete turnkey solution.",
      },
      {
        q: "What about backup?",
        a: "Solar alone: 80% of winter days. Summer: 100%. Gas/electric backup highly recommended.",
      },
    ],
  },

  {
    id: 31,
    name: "Commercial Water Softener",
    category: "solar-commercial",
    price: 165000,
    warranty: "1 Year",
    efficiency: "Softener | 2000 LPH",
    image: "/images/softner.jpg",
    description:
      "Industrial-grade softener reducing hardness to protect plumbing and boilers. Large-capacity ion-exchange system.",
    features: [
      "Ion-exchange resin",
      "Auto/Manual regeneration",
      "High-flow valves",
      "FRP/SS vessel",
      "Hardness removal",
      "Scale prevention",
    ],
    specs: {
      brand: "Supreme (Commercial Grade)",
      type: "Water Softener (Ion-Exchange)",
      capacity: "2000 LPH (Liters Per Hour)",
      technology: "Ion-exchange resin process",
      resin: "Food-grade cation exchange resin",
      regeneration: "Auto (timer) or Manual",
      control: "Digital control panel with display",
      vesselMaterial: "FRP (Fiber Reinforced Plastic) or Stainless Steel",
      valves: "High-flow multi-port valves (durable)",
      hardnessRemoval: "Up to 1000 ppm hardness input → <10 ppm output",
      softeners: "Reduces limescale, extends boiler life",
      installation: "Commercial setting (kitchen, boiler room, central water system)",
      warranty: "1 Year",
      ideal: "Hotels, hospitals, industries, laundries, large residential complexes",
    },
    faqs: [
      {
        q: "Why soften water?",
        a: "Hardness damages pipes, blocks boilers, reduces appliance life. Softener prevents this, saves ₹50,000+ annually.",
      },
      { q: "Auto vs manual regeneration?", a: "Auto: convenient, uses water/salt. Manual: control when to clean." },
      { q: "Resin lifespan?", a: "5–10 years. Replacement cost ₹10,000–15,000." },
    ],
  },

  {
    id: 32,
    name: "Commercial RO Plant",
    category: "solar-commercial",
    price: 245000,
    warranty: "1 Year",
    efficiency: "RO | LPH Variants",
    image: "/images/commercial-ro-plant-500x500.webp",
    description:
      "High-capacity RO with robust pre-treatment and TDS reduction for institutions. Scalable water purification.",
    features: [
      "Multi-stage filtration",
      "Low TDS output (<50 ppm)",
      "SS/FRP skids",
      "Inline monitoring",
      "Scalable LPH options",
      "Minimal wastage",
    ],
    specs: {
      brand: "Supreme (Commercial RO)",
      type: "Commercial RO Plant",
      capacity: "25–5000 LPH (choose variant)",
      availableLph: ["25 LPH", "50 LPH", "100 LPH", "200 LPH", "500 LPH", "1000 LPH", "2000 LPH", "5000 LPH"],
      filtration: "Multi-stage (sediment, carbon, RO, post-carbon)",
      tdsFinalOutput: "<50 ppm (pure water)",
      wastageRatio: "Low (2:1 or better with recovery system)",
      pretreatment: "Included (water softener + carbon filters)",
      skidMaterial: "Stainless Steel (SS) or FRP (optional)",
      monitoring: "Inline TDS meter + pressure gauge",
      tankCapacity: "Varies (can be customized)",
      installation: "Commercial site (kitchen, lab, bottling plant, hospital)",
      warranty: "1 Year (equipment + labor)",
      ideal: "Hotels, hospitals, bottling plants, laboratories, large complexes, industries",
      maintenanceCost: "₹3,000–8,000/month (filter changes, cartridge replacements)",
      roi: "2–3 years (compared to bottled water bulk purchase)",
    },
    faqs: [
      {
        q: "Which LPH to choose?",
        a: "25 LPH = 600 L/day (guest house). 100 LPH = 2400 L/day (hotel). 500 LPH = 12,000 L/day (large hospital).",
      },
      { q: "What's included?", a: "RO skid, pre-treatment filters, inline monitoring, plumbing, installation." },
      { q: "Maintenance cost?", a: "₹3,000–8,000/month depending on capacity and local water quality." },
      {
        q: "TDS 50 ppm—is it safe to drink?",
        a: "Yes, but add mineral retention if desired. Pure water (low TDS) is fine but lacks minerals.",
      },
    ],
  },


  // Purosis Plus (White)
  {
    id: 34,
    name: "Purosis Plus RO (White)",
    category: "purifier",
    price: 11999,
    warranty: "1 Year",
    efficiency: "RO | Household",
    image: "/images/purosiswhite.png",
    description:
      "Purosis Plus variant with upgraded design and reliable multi-stage RO filtration. White body for modern kitchens.",
    features: [
      "Multi-stage RO purification",
      "Sediment + carbon pre-filtration",
      "Taste enhancer (post-carbon)",
      "Wall-mount ready",
      "Serviceable filters",
    ],
    specs: {
      brand: "Purosis",
      model: "Purosis Plus (White)",
      purificationType: "RO (Reverse Osmosis)",
      stages: "4–5 stages (sediment, carbon, RO, post-carbon/taste enhancer)",
      storageCapacity: "8 Litres",
      flowRate: "10–12 LPH",
      tdsRange: "Up to 2000 ppm input",
      filterLife: "12–18 months (depends on TDS)",
      warranty: "1 Year (Purosis service)",
      installation: "Wall-mounted",
      ideal: "Families needing reliable RO with a premium look",
      annualServiceCost: "₹2,000–3,500",
    },
    faqs: [
      { q: "Is this different from Purosis RO?", a: "Yes. Plus variant typically comes with updated body/design and similar RO performance depending on configuration." },
      { q: "What water TDS is it suitable for?", a: "Works well up to ~2000 ppm input; for very high TDS, ensure membrane quality and timely service." },
      { q: "How often to change filters?", a: "Usually every 12–18 months (earlier if input water is hard/high TDS)." },
    ],
  },

  // Purosis Plus (Black)
  {
    id: 35,
    name: "Purosis Plus RO (Black)",
    category: "purifier",
    price: 12999,
    warranty: "1 Year",
    efficiency: "RO | Household",
    image: "/images/purosisplus.png",
    description:
      "Purosis Plus RO in black finish with dependable daily purification and a premium look for modular kitchens.",
    features: [
      "Multi-stage RO purification",
      "Sediment + carbon pre-filtration",
      "Taste enhancer (post-carbon)",
      "Wall-mount ready",
      "Serviceable filters",
    ],
    specs: {
      brand: "Purosis",
      model: "Purosis Plus (Black)",
      purificationType: "RO (Reverse Osmosis)",
      stages: "4–5 stages (sediment, carbon, RO, post-carbon/taste enhancer)",
      storageCapacity: "8 Litres",
      flowRate: "10–12 LPH",
      tdsRange: "Up to 2000 ppm input",
      filterLife: "12–18 months (depends on TDS)",
      warranty: "1 Year (Purosis service)",
      installation: "Wall-mounted",
      ideal: "Premium kitchens, users who prefer black finish",
      annualServiceCost: "₹2,000–3,500",
    },
    faqs: [
      { q: "Is black only color difference?", a: "Functionally similar; exact internals depend on the variant you stock (UV/UF/mineral can be added if required)." },
      { q: "Does it need electricity?", a: "Yes, RO uses a pump and needs power." },
      { q: "Can it be serviced locally?", a: "Yes, filters and membrane are serviceable; schedule periodic maintenance for best output." },
    ],
  },

  // ========== ROOFTOP SOLAR SOLUTIONS ==========



  {
    id: 36,
    name: "On-Grid Rooftop Solar 2 kW",
    category: "rooftop-solar",
    price: 135000,
    originalPrice: 150000,
    warranty: "25 Years Panel Performance | 5 Years Installation",
    efficiency: "2 kW | On-Grid",
    image: "/images/IND-Rooftop-Solar-1.jpg",
    description:
      "Popular residential rooftop solar system for medium-sized homes. Handles fans, lights, TV, refrigerator, and daily household loads efficiently.",
    features: [
      "High-efficiency Mono PERC panels",
      "Net metering compatible",
      "Rust-proof structure",
      "Remote inverter monitoring",
      "Long lifespan",
      "Subsidy eligible (where applicable)",
    ],
    specs: {
      brand: "Supreme Solar",
      systemType: "On-Grid Rooftop Solar",
      capacity: "2 kW",
      dailyGeneration: "8–10 Units/day",
      monthlyGeneration: "240–300 Units/month",
      panelType: "Mono PERC Half-Cut",
      inverterType: "Grid-Tie Inverter",
      installationArea: "~200 sq.ft",
      suitableFor: "2 BHK homes",
      netMetering: "Supported",
      idealFor: "Medium electricity consumers",
      paybackPeriod: "3–5 Years",
    },
    faqs: [
      {
        q: "Can I run an AC?",
        a: "Yes, one 1-ton inverter AC during daytime usage is possible.",
      },
      {
        q: "Is subsidy available?",
        a: "Yes, depending on state and central government schemes.",
      },
    ],
  },



  {
    id: 37,
    name: "On-Grid Rooftop Solar 5 kW",
    category: "rooftop-solar",
    price: 315000,
    originalPrice: 350000,
    warranty: "25 Years Panel Performance | 5 Years Installation",
    efficiency: "5 kW | On-Grid",
    image: "/images/solar roof 3.jpg",
    description:
      "Premium rooftop solar solution for villas, duplex homes, offices, and commercial establishments with high electricity bills.",
    features: [
      "Commercial-grade solar panels",
      "High-capacity inverter",
      "Remote monitoring app",
      "Strong galvanized structure",
      "Designed for long-term savings",
      "Subsidy support",
    ],
    specs: {
      brand: "Supreme Solar",
      systemType: "On-Grid Rooftop Solar",
      capacity: "5 kW",
      dailyGeneration: "20–25 Units/day",
      monthlyGeneration: "600–750 Units/month",
      installationArea: "~500 sq.ft",
      suitableFor: "Large homes / Villas / Offices",
      inverterType: "Commercial Grid-Tie Inverter",
      panelType: "Mono PERC Half-Cut",
      netMetering: "Supported",
      idealFor: "High EB bill reduction",
      paybackPeriod: "3–5 Years",
    },
    faqs: [
      {
        q: "Can this reduce my electricity bill to near zero?",
        a: "For many homes and offices, yes — especially with daytime consumption and net metering.",
      },
      {
        q: "Can batteries be added later?",
        a: "Yes, hybrid upgrades are possible in future.",
      },
    ],
  },

  {
    id: 38,
    name: "Hybrid Rooftop Solar 5 kW with Battery Backup",
    category: "rooftop-solar",
    price: 495000,
    originalPrice: 550000,
    warranty: "25 Years Panel Performance | 5 Years Installation",
    efficiency: "5 kW | Hybrid",
    image: "/images/hybrid rooftop.webp",
    description:
      "Hybrid rooftop solar system with battery backup for uninterrupted power during outages while still reducing electricity bills.",
    features: [
      "Battery backup support",
      "Works during power cuts",
      "Hybrid inverter technology",
      "Smart monitoring",
      "Expandable battery storage",
      "Premium safety protections",
    ],
    specs: {
      brand: "Supreme Solar",
      systemType: "Hybrid Solar System",
      capacity: "5 kW",
      batteryBackup: "5–10 kWh (customizable)",
      dailyGeneration: "20–25 Units/day",
      installationArea: "~550 sq.ft",
      inverterType: "Hybrid Inverter",
      panelType: "Mono PERC",
      suitableFor: "Homes needing backup + savings",
      idealFor: "Areas with frequent power cuts",
      backupSupport: "Fans, lights, fridge, WiFi, TVs, selected AC loads",
    },
    faqs: [
      {
        q: "What is the difference between on-grid and hybrid?",
        a: "Hybrid systems include battery backup and continue supplying power during outages.",
      },
      {
        q: "Is battery replacement expensive?",
        a: "Lithium batteries last 8–12 years and require very low maintenance.",
      },
    ],
  },


  // ========== HEAT PUMPS ==========
  {
    id: 39,
    name: "Heat Pump Water Heater 100 LPH",
    category: "heat-pump",
    price: 90000,
    originalPrice: 98000,
    warranty: "2 Years",
    efficiency: "COP up to 3.4 | 100 LPH",
    image: "/images/heatpump.jpg",
    description:
      "Compact commercial heat pump delivering high energy savings with reliable all-weather performance.",
    features: [
      "COP up to 3.4",
      "Energy-efficient heating",
      "Works in all weather conditions",
      "Low-noise operation",
      "Smart digital controls",
      "Eco-friendly refrigerant (R32)",
      "Fast heating performance",
    ],
    specs: {
      brand: "Premium (Supreme Recommended)",
      technology: "Air-Source Heat Pump",
      capacity: "100 LPH",
      cop: "Up to 3.4",
      powerConsumption: "Energy-saving operation",
      operatingTemperature: "2°C to 43°C",
      refrigerant: "R32",
      warranty: "2 Years Compressor, 5 Years Tank",
      ideal: "Small homes, villas, cafes, salons",
    },
  },

  {
    id: 40,
    name: "Heat Pump Water Heater 150 LPH",
    category: "heat-pump",
    price: 110000,
    originalPrice: 118000,
    warranty: "2 Years",
    efficiency: "COP up to 3.4 | 150 LPH",
    image: "/images/heatpump.jpg",
    description:
      "Mid-capacity heat pump suitable for homes and small commercial establishments with reduced electricity costs.",
    features: [
      "COP up to 3.4",
      "70% less electricity consumption",
      "All-weather operation",
      "Quiet compressor technology",
      "Digital controller",
      "Eco-friendly refrigerant",
    ],
    specs: {
      brand: "Premium (Supreme Recommended)",
      technology: "Air-Source Heat Pump",
      capacity: "150 LPH",
      cop: "Up to 3.4",
      operatingTemperature: "2°C to 43°C",
      refrigerant: "R32",
      warranty: "2 Years Compressor, 5 Years Tank",
      ideal: "Homes, hostels, restaurants",
    },
  },

  {
    id: 41,
    name: "Heat Pump Water Heater 200 LPH",
    category: "heat-pump",
    price: 138000,
    originalPrice: 145000,
    warranty: "2 Years",
    efficiency: "COP up to 3.4 | 200 LPH",
    image: "/images/heatpump500ltr.jpg",
    description:
      "High-efficiency heat pump delivering reliable hot water with major electricity savings.",
    features: [
      "COP up to 3.4",
      "Up to 70% power savings",
      "Whisper-quiet operation",
      "Fast heating",
      "Smart controls",
      "Eco-friendly refrigerant",
    ],
    specs: {
      brand: "Premium (Supreme Recommended)",
      technology: "Air-Source Heat Pump",
      capacity: "200 LPH",
      cop: "Up to 3.4",
      operatingTemperature: "2°C to 43°C",
      refrigerant: "R32",
      warranty: "2 Years Compressor, 5 Years Tank",
      ideal: "Large homes, hotels, apartments",
    },
  },

  {
    id: 42,
    name: "Heat Pump Water Heater 300 LPH",
    category: "heat-pump",
    price: 160000,
    originalPrice: 172000,
    warranty: "2 Years",
    efficiency: "COP up to 3.5 | 300 LPH",
    image: "/images/heatpump.jpg",
    description:
      "Commercial-grade heat pump designed for continuous hot water demand with maximum efficiency.",
    features: [
      "High COP efficiency",
      "Commercial-duty compressor",
      "24/7 operation support",
      "Low maintenance",
      "Silent performance",
      "Eco-friendly refrigerant",
    ],
    specs: {
      brand: "Premium (Supreme Recommended)",
      technology: "Air-Source Heat Pump",
      capacity: "300 LPH",
      cop: "Up to 3.5",
      operatingTemperature: "2°C to 43°C",
      refrigerant: "R32",
      warranty: "2 Years Compressor, 5 Years Tank",
      ideal: "Hotels, hospitals, hostels",
    },
  },

  {
    id: 43,
    name: "Heat Pump Water Heater 500 LPH",
    category: "heat-pump",
    price: 220000,
    originalPrice: 235000,
    warranty: "2 Years",
    efficiency: "COP up to 3.5 | 500 LPH",
    image: "/images/heatpump.jpg",
    description:
      "Heavy-duty industrial heat pump suitable for large-scale hot water applications.",
    features: [
      "Industrial-grade performance",
      "Massive electricity savings",
      "Continuous heating support",
      "Smart temperature management",
      "Low operational noise",
      "Eco-friendly refrigerant",
    ],
    specs: {
      brand: "Premium (Supreme Recommended)",
      technology: "Air-Source Heat Pump",
      capacity: "500 LPH",
      cop: "Up to 3.5",
      operatingTemperature: "2°C to 43°C",
      refrigerant: "R32",
      warranty: "2 Years Compressor, 5 Years Tank",
      ideal: "Industries, resorts, hospitals, apartments",
    },
  },

  {
    id: 44,
    name: "Heat Pump Water Heater 1000 LPH",
    category: "heat-pump",
    price: 415000,
    originalPrice: 435000,
    warranty: "2 Years",
    efficiency: "COP up to 3.6 | 1000 LPH",
    image: "/images/heatpump.jpg",
    description:
      "Ultra high-capacity industrial heat pump built for large commercial and institutional usage.",
    features: [
      "Maximum energy efficiency",
      "Industrial continuous operation",
      "Advanced digital controls",
      "High-capacity hot water production",
      "Durable heavy-duty design",
      "Eco-friendly refrigerant",
    ],
    specs: {
      brand: "Premium (Supreme Recommended)",
      technology: "Air-Source Heat Pump",
      capacity: "1000 LPH",
      cop: "Up to 3.6",
      operatingTemperature: "2°C to 43°C",
      refrigerant: "R32",
      warranty: "2 Years Compressor, 5 Years Tank",
      ideal: "Large hotels, factories, institutions, hospitals",
    },
  },


];




